import { render, staticRenderFns } from "./accountProfil.vue?vue&type=template&id=18375baf&scoped=true&"
import script from "./accountProfil.vue?vue&type=script&lang=js&"
export * from "./accountProfil.vue?vue&type=script&lang=js&"
import style0 from "./accountProfil.vue?vue&type=style&index=0&id=18375baf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18375baf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFlex,VLayout,VTextField})
